import { Col, ColProps, Form, FormInstance, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { ClientGroupsFilterFormModel } from '../../../models/client-groups-filter-form-model';
import { clientGroupsFilterFormId } from '../../../constants/constants';

interface Props {
  form: FormInstance<ClientGroupsFilterFormModel>;
}

const ClientGroupsFilterForm = ({ form }: Props): JSX.Element => {
  const { t } = useTranslation(['client-groups', 'common']);
  const columnsGrid: ColProps = { xs: 24, sm: 12, md: 6 };

  return (
    <Form id={clientGroupsFilterFormId} form={form} layout="vertical">
      <Row gutter={18} align="bottom" justify="end">
        <Col flex="auto">
          <Row gutter={18}>
            <Col {...columnsGrid}>
              <Form.Item
                name="name"
                label={t('label.name', { ns: 'common' })}
                rules={[
                  {
                    max: 255,
                    message: t('errors.nameTooLong', { ns: 'common' }),
                  },
                ]}
              >
                <Input placeholder={t('clientGroupsFilterForm.placeholder.name')} />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default ClientGroupsFilterForm;
